import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';

/*
  Generated class for the ThemeProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ThemeProvider {

  public applicationTheme = 'dark-theme';


  constructor() {
  }

  public changerTheme(){
    if(this.applicationTheme === 'dark-theme'){
      this.applicationTheme = 'light-theme';
    } else {
      this.applicationTheme = 'dark-theme';
    }
  }

  public getSchemaImage(): string{
    return this.applicationTheme === 'dark-theme' ? 'assets/img/bar-schema-white.png' : 'assets/img/bar-schema-black.png';
  }

}



// WEBPACK FOOTER //
// ./src/providers/theme/theme.ts